import { createClient } from "@supabase/supabase-js";

// CRA's browser build cannot evaluate the generated Vite client's import.meta.env.
// These are public Cloud settings, not private credentials. Keep one shared
// client for legacy services and use Cloud's default auth storage key.
const url = "https://ushczdejyoqweatsmllg.supabase.co";
const key = "sb_publishable_-KcKuZoy_nTkXEa3hATlkQ_cUXzZ-EE";

export const supabase = createClient(url, key, {
  global: {
    fetch: (input, init) => {
      const headers = new Headers(typeof Request !== "undefined" && input instanceof Request ? input.headers : undefined);
      new Headers(init?.headers).forEach((value, name) => headers.set(name, value));
      if (headers.get("Authorization") === `Bearer ${key}`) headers.delete("Authorization");
      headers.set("apikey", key);
      return fetch(input, { ...init, headers });
    },
  },
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    storage: typeof window !== "undefined" ? window.localStorage : undefined,
  },
});
